








































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import CreateSkuMapping from './skumapping-add.vue'
import TotalInStock from './totalinstock-history.vue'
import TotalOutStock from './totaloutstock-history.vue'
import LaveStock from './lavestock-history.vue'
import SafeStock from './safestock-add.vue'
import LookSkuMapping from './skumapping-look.vue'
import EditStockProduct from './stockproduct-edit.vue'
import EditCombinationstock from './edit-combinationstock.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import moment from 'moment'
Vue.use(Preview);

class PagefrontstockproductRequest extends PageRequest {
    beginTime?: Date;
    endTime?: Date;
    productName: string;
    storeId?: number;
    productSku: string;
    minSafeStock?: number;
    maxSafeStock?: number;
    productNo: string;
    minStock?: number;
    maxStock?: number;
    stockstatus?: number;
    IsCombination?: boolean;
}

@Component({
    name: "frontstockproduct",
    components: { CreateSkuMapping, LookSkuMapping, TotalInStock, TotalOutStock, LaveStock, SafeStock, EditStockProduct, EditCombinationstock }
})
export default class frontstockproduct extends AbpBase {
    editModalShow: boolean = false;
    supplyModalShow: boolean = false;
    totalinstockModalShow: boolean = false;
    totaloutstockModalShow: boolean = false;
    lookModalShow: boolean = false;
    lavestockModalShow: boolean = false;
    safeStockModalShow: boolean = false;
    stockProductModalShow: boolean = false;
    combinationStockShow: boolean = false;
    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PagefrontstockproductRequest = new PagefrontstockproductRequest();
    IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
    stockstatusList = Enums.getEnum(Enums.StockStatus, true);
    urgentStatus = Enums.getEnum(Enums.WhetherHandleStatus, true);
    //creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    creationTime: Date[];
    createModalShow: boolean = false;

    get list() {
        return this.$store.state.frontstockproduct.list;
    };
    get loading() {
        return this.$store.state.frontstockproduct.loading;
    }

    pageChange(page: number) {
        this.$store.commit('frontstockproduct/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('frontstockproduct/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.user.currentPage = 1;
        this.getpage();
    }
    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }
        this.getData();
        await this.$store.dispatch({
            type: 'frontstockproduct/getAll',
            data: this.pagerequest
        })

    }
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        this.storeaddressList.push(a);
    }
    async stockAvailable(data) {
        await this.$store.dispatch({
            type: 'frontstockproduct/UpdateStockProductAvailable',
            data: { stockId: data.id, }

        });
        this.getData();
        this.getpage();
    }
    async EditSafeStockNum(data: any) {
        this.$store.state.frontstockproduct.id = data.id;
        this.$store.state.frontstockproduct.safeStockNum = data.safeStock;
        this.safeStockModalShow = true;


    }
    async EditProduct(data: any) {
        this.$store.state.frontstockproduct.id = data.id;
        this.$store.state.frontstockproduct.productName = data.productName;
        this.$store.state.frontstockproduct.productSku = data.productSku;
        this.$store.state.frontstockproduct.purchaseCost = data.purchaseCost;
        this.$store.state.frontstockproduct.platformInfo = data.platformInfo;
        this.stockProductModalShow = true;
    }
    async stockNotAvailable(data) {
        await this.$store.dispatch({
            type: 'frontstockproduct/UpdateStockProductNotAvailable',
            data: { stockId: data.id, }

        });
        this.getpage();
    }
    async stockDisable(data) {
        this.$Modal.confirm({
            title: "禁用产品", content: "确定将【" + data.productName + "】标记为禁用，如果标记为禁用，则不可恢复，将停止仓储费扣费!", onOk: async () => {
                await this.$store.dispatch({
                    type: 'frontstockproduct/UpdateStockProductDisable',
                    data: { stockId: data.id, }

                });
                this.getpage();
            }
        });
    }
    async cancleCombinationStock(data) {
        this.$Modal.confirm({
            title: "取消组合", content: "确定将【" + data.productName + "】取消组合CP么!", onOk: async () => {
                await this.$store.dispatch({
                    type: 'frontstockproduct/cancleCombinationStock',
                    data: { Id: data.id, }

                });
                this.getpage();
            }
        });
    }

    async editCombinationStock(data: any) {
        this.$store.state.frontstockproduct.id = data.id;
        this.$store.state.frontstockproduct.combinationItems = data.items;
        this.combinationStockShow = true;
    }


    //async showmodel(data: any) {
    //    this.$store.state.frontstockproduct.id = data;
    //    this.editModalShow = true;
    //}
    async addskumapping(data: any) {
        this.$store.state.frontstockproduct.id = data.id;
        this.$store.state.frontstockproduct.sku = data.productSku;
        this.createModalShow = true;
    }
    async lookskumapping(data: any) {
        this.$store.state.frontstockproduct.id = data.id;
        this.lookModalShow = true;
    }
    async showmodel(data: any, type: number) {
        this.$store.state.frontstockproduct.id = data.id;
        if (type == 1) {
            //入库总量历史
            this.totalinstockModalShow = true;
        }
        else if (type == 2) {
            //出库总量历史
            this.totaloutstockModalShow = true;
        }
        else {
            //库存量历史
            this.lavestockModalShow = true;
        }
    }
    async stockup(data: any) {
        this.$store.state.frontstockproduct.id = data.id;

        this.supplyModalShow = true;
    }
    get pageSize() {
        return this.$store.state.frontstockproduct.pageSize;
    }
    get totalCount() {
        return this.$store.state.frontstockproduct.totalCount;
    }
    get currentPage() {
        return this.$store.state.frontstockproduct.currentPage;
    }
    columns = [
        //{
        //    title: '国内物流单号',
        //     key: 'logisticsNumber',
        //    width: 150,

        //    },
        {
            title: '备货入库仓库',
            key: 'storeName',
            width: 150,
            fixed: 'left',
        },
        //{
        //    title: '产品类型',
        //    width: 90,
        //    key: 'productType',
        //    render: (h: any, params: any) => {
        //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
        //    }
        //    },
        {
            title: '产品编号',
            key: 'productNo',
            width: 170,
        },
        {
            title: '产品状态',
            key: 'stockStatus',
            width: 100,
            render: (h: any, params: any) => {
                return h('span', Enums.StockStatus.filter(function (item) { return item.value == params.row.stockStatus })[0].name);
            }
        },
        {
            title: '产品图片',
            key: 'productImgGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.productImgGuid) {
                    var data = { imageGuid: params.row.productImgGuid, url: null };
                    var url = "";
                    if (params.row.productImgGuid.indexOf("http") != -1) {
                        url = params.row.productImgGuid;
                    }
                    else {
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        url = data.url;
                    }
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "cp"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        {
            title: '组合',
            key: 'isCombination',
            width: 70,
            render: (h: any, params: any) => {
                return h('span', params.row.isCombination ? "是" : "否",
                )
            }
        },
        {
            title: '组合信息',
            key: 'isCombination',
            width: 230,
            render: (h: any, params: any) => {
                if (!params.row.items || params.row.items.length === 0) {
                    return h('span', { style: { color: '#c5c8ce' } }, '');
                }

                return h('div', params.row.items.map((item: any) => {
                    return h('div', {
                        style: {
                            marginBottom: '4px',
                            fontSize: '12px',
                            lineHeight: '1.4'
                        }
                    }, [
                        h('span', {
                            style: {
                                color: '#515a6e',
                                fontWeight: 'bold'
                            }
                        }, item.productNo || '未知'),
                        h('font', {
                            style: {
                                color: 'red',
                                margin: '0 2px'
                            }
                        }, '*'),
                        h('span', {
                            style: {
                                color: '#808695'
                            }
                        }, `${item.count || 0}`),
                        h('span', {
                            style: {
                                color: '#19be6b',
                                marginLeft: '4px',
                                fontSize: '11px'
                            }
                        }, `库存:${item.inventory || 0}`)
                    ]);
                }));
            }
        },
        {
            title: '产品Sku',
            key: 'productSku',
            width: 250,
        },
        {
            title: '商品名称',
            key: 'productName',
            width: 250,
        },
        {
            title: '安全库存',
            key: 'safeStock',
            width: 100,
        },
        {
            title: '入库总量',
            key: 'totalStorage',
            width: 100,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodel(params.row, 1) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalStorage);
            }
        },
        {
            title: '出库总量',
            key: 'totalOutgoing',
            width: 100,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodel(params.row, 2) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalOutgoing);
            }
        },
        {
            title: '库存量',
            key: 'inventory',
            width: 100,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodel(params.row, 3) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.inventory);
            }
        },
        {
            title: '采购价格',
            key: 'purchaseCost',
            width: 100,

        },
        {
            title: '货架位置',
            key: 'shelfPosition',
            width: 200,

        },
        {
            title: '第三方平台Sku映射',
            key: '',
            width: 200,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.lookskumapping(params.row) } }, style: { color: a, 'text-decoration': 'underline' } }, "查看");
            }
        },
        //{
        //    title: '扣费周期/积分',
        //    key: 'deductionCycle',
        //    width: 200,
        //},
        //    width: 200,
        //},

        //{
        //    title: '商品数量',
        //    key: 'productNums',
        //    width: 200,
        //},
        //{
        //    title: '采购成本',
        //    key: 'purchaseCost',
        //    width: 200,
        //},

        {
            title: '操作',
            width: 120,
            fixed: 'right',
            key: 'id',
            render: (h, params) => {
                const _this = this;
                const data = params.row;
                const menuItems = [];

                // 根据条件添加菜单项
                if (data.isCheckBy == null) {
                    menuItems.push({ name: 'addSkuMapping', label: '新增Sku映射' });
                    menuItems.push({ name: 'editSafeStock', label: '修改安全库存' });
                }

                menuItems.push({ name: 'editProduct', label: '编辑产品' });

                if (data.stockStatus == 1) {
                    menuItems.push({ name: 'markAvailable', label: '标记为可用' });
                }

                if (data.stockStatus == 0) {
                    menuItems.push({ name: 'markUnavailable', label: '标记为不可用' });
                }

                if (data.stockStatus == 1 || data.stockStatus == 0) {
                    menuItems.push({ name: 'markDisabled', label: '标记为禁用' });
                }

                if (data.isCombination) {
                    menuItems.push({ name: 'cancelCombination', label: '取消组合CP' });
                }

                if (data.inventory == 0) {
                    menuItems.push({ name: 'manageCombination', label: '管理组合CP' });
                }

                return h('div', [
                    h('Dropdown', {
                        props: {
                            transfer: true,
                            trigger: 'click'
                        },
                        on: {
                            'on-click': (name) => {
                                switch (name) {
                                    case 'addSkuMapping':
                                        _this.addskumapping(data);
                                        break;
                                    case 'editSafeStock':
                                        _this.EditSafeStockNum(data);
                                        break;
                                    case 'editProduct':
                                        _this.EditProduct(data);
                                        break;
                                    case 'markAvailable':
                                        _this.stockAvailable(data);
                                        break;
                                    case 'markUnavailable':
                                        _this.stockNotAvailable(data);
                                        break;
                                    case 'markDisabled':
                                        _this.stockDisable(data);
                                        break;
                                    case 'cancelCombination':
                                        _this.cancleCombinationStock(data);
                                        break;
                                    case 'manageCombination':
                                        _this.editCombinationStock(data);
                                        break;
                                }
                            }
                        }
                    }, [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '90px'
                            }
                        }, '操作'),
                        h('DropdownMenu', {
                            slot: 'list'
                        }, menuItems.map(item => {
                            return h('DropdownItem', {
                                props: {
                                    name: item.name
                                }
                            }, item.label);
                        }))
                    ])
                ]);
            }
        }
    ]
    async created() {

        this.getpage();
    }
}
